import React, { useEffect, useState } from 'react';
import ReactGA4 from 'react-ga4';
import { Route, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/browser';

import { PathPerformance, pathActiveConnections } from './requestRecord';

type Props = {
  options: any[];
};

export interface IPerformance {
  currentPageStartTime: number;
  currentPageFetchFinishTime?: number;
  currentPageLocation: string;
  currentPageIsCached: boolean;
  currentPageReported: boolean;
}

const FETCH_TIME_MIN = 3000;

// 测试顺序
let isInit_currentPagePerformance = false;

const GoogleAnalytics: React.FC<Props> = props => {
  const location = useLocation();
  const [cachedPages, setCachedPages] = useState<string[]>([]);

  useEffect(() => {
    const origin = window.location.origin;
    const page = `${location.pathname}${location.search}`;
    ((window as any)._currentPagePerformance as IPerformance) = {
      currentPageStartTime: +new Date(),
      currentPageLocation: `${page}`,
      currentPageIsCached: cachedPages.indexOf(page) !== -1,
      currentPageReported: false,
    };
    isInit_currentPagePerformance = true;
    ReactGA4.set({
      page: `${page}`,
      location: `${origin}${page}`,
      ...props.options,
    });
    ReactGA4.send({ hitType: 'pageview', page });
    setCachedPages([...cachedPages, `${page}`]);
    // eslint-disable-next-line
  }, [location.pathname]);

  return null;
};

const RouteTracker = () => <Route component={GoogleAnalytics} />;
function GetQueryString(name: string) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

const walletName = GetQueryString('utm_source');
const init = (options = {}) => {
  const isGAEnabled = process.env.NODE_ENV === 'production';

  if (isGAEnabled && !ReactGA4.isInitialized) {
    ReactGA4.initialize(
      [
        {
          trackingId: 'G-XCH1EEPRPW',
        },
        {
          trackingId: 'UA-160311039-1',
        },
      ],
      {
        nonce: process.env.CSP_NONCE_GA,
      },
    );

    setTimeout(() => {
      walletName &&
        ReactGA4.event({
          category: 'utm_source',
          action: `${walletName}`,
        });
    });
    document.addEventListener('SPAPageLoad', event => {
      const performance: IPerformance = (window as any)._currentPagePerformance as IPerformance;
      const pathPerformance = (event as any)?.detail as PathPerformance;
      if (!performance) {
        const id = Math.random();
        Sentry.captureException(
          new Error(
            `上报异常 ${id}:${JSON.stringify(
              performance,
            )} isInit_currentPagePerformance:${isInit_currentPagePerformance} event=${JSON.stringify(
              event,
            )}`,
          ),
        );
        setTimeout(() => {
          Sentry.captureException(
            new Error(
              `300ms上报异常 ${id}:${JSON.stringify(
                (window as any)._currentPagePerformance as IPerformance,
              )} isInit_currentPagePerformance:${isInit_currentPagePerformance} event=${JSON.stringify(
                event,
              )}`,
            ),
          );
        }, 300);
        return;
      }
      if (performance.currentPageIsCached || performance.currentPageReported) {
        return;
      }
      if (performance.currentPageLocation !== pathPerformance.path) {
        return;
      }
      const duration = pathPerformance.endTime - performance.currentPageStartTime;
      if (duration < FETCH_TIME_MIN) {
        setTimeout(() => {
          if (
            !performance.currentPageReported &&
            (pathActiveConnections.get(pathPerformance.path) || 0) === 0
          ) {
            ReactGA4.event('timing_complete', {
              category: pathPerformance.path,
              label: 'load',
              value: duration,
            });
            performance.currentPageReported = true;
            performance.currentPageFetchFinishTime = pathPerformance.endTime;
          }
        }, FETCH_TIME_MIN);
      } else {
        ReactGA4.event('timing_complete', {
          category: performance.currentPageLocation,
          label: 'load',
          value: duration,
        });
        performance.currentPageReported = true;
        performance.currentPageFetchFinishTime = pathPerformance.endTime;
      }
    });
  }

  return isGAEnabled;
};

export default {
  GoogleAnalytics,
  RouteTracker,
  init,
};
